import { differenceInYears } from 'date-fns/differenceInYears';

// This function assumes it is receiving a valid date (YYYY-MM-DD)
const isYoungEnough = (value: string, ageLimit: number = 125, timeZone: string = '') => {
  if (value && value.length === 10) {
    // Gets current date
    const limit = timeZone !== '' ? new Date(new Date().toLocaleString('en-US', { timeZone })) : new Date();

    // Makes date object of given value
    const [year, month, day] = value.split('-');
    if (year.charAt(0) === '0') {
      return false;
    }

    const selected = new Date(Number.parseInt(year, 10), Number.parseInt(month, 10) - 1, Number.parseInt(day, 10));

    // Finds age difference and compares to ageLimit given
    // @ts-ignore
    return differenceInYears(limit, selected) <= ageLimit;
  }
  return false;
};

export default isYoungEnough;
